<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">账户</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">实名认证</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="th-panel-title">实名认证</div>
      </div>
      <div class="panel-body z-margin-bottom-25-precent">
        <div v-if="cert_state == 100">
          <div class="alert-warn z-margin-bottom-20-precent">
            <p>根据《中华人民共和国网络安全法》等网络安全相关法律法规规定，及按网监，公安等有关监管单位要求，国内云计算资源用户须完成用户实名认证才能使用相关服务。请您认真填写相关实名认证信息，完成实名认证申请。</p>
          </div>
          <div class="licontant ub-box ub-between z-box-sizing">
            <div class="ub-box">
              <div class="iconimg"></div>
              <div class="z-margin-left-15-precent z-lineHeight-35">
                <div class="z-font-size-18 z-color-000">
                  个人实名认证（手机号码+验证实名）
                  <el-button class="z-margin-left-50-precent" type="primary" @click="goPersonal">立即验证</el-button>
                </div>
                <div class="z-font-size-12 z-color-999">注：手机号码必须与实名认证人信息一致，请勿使用他人手机进行验证实名，否则会认证失败。</div>
              </div>
            </div>
          </div>
          <div class="licontant ub-box ub-between z-box-sizing">
            <div class="ub-box">
              <div class="iconimg company"></div>
              <div class="z-margin-left-15-precent z-lineHeight-35">
                <div class="z-font-size-18 z-color-000">
                  企业实名认证（银行卡号+打款实名）
                  <el-button class="z-margin-left-50-precent" type="primary" @click="goEnterprise">立即验证</el-button>
                </div>
                <div class="z-font-size-12 z-color-999">银行卡号码必须与实名认证企业信息一致，请勿使用其他企业银行卡进行验证，否则会认证失败。</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="cert_state == 2" class="auth-container clearfix">
          <div class="auth-content clearfix">
            <div class="auth-content-left"></div>
            <div class="auth-content-right">
              <h4>恭喜您已通过阿贝云实名认证！</h4>
              <p>
                <span>认证类型：</span>
                {{info.smrz_type}}
              </p>
              <p v-if="info.smrz_type === '阿贝云个人认证'">
                <span>真实姓名：</span>
                {{info.smrz_name}}
              </p>
              <p v-if="info.smrz_type === '阿贝云企业认证'">
                <span>企业名称：</span>
                {{info.smrz_name}}
              </p>
              <p>
                <span>证件号码：</span>
                {{info.smrz_id}}
              </p>
              <p>
                <span>认证时间：</span>
                {{info.cert_time}}
              </p>
              <p>如果需要修改认证信息请联系客服人员</p>
            </div>
          </div>
        </div>
        <div v-if="cert_state == 0 || cert_state == 1" class="auth-container clearfix">
          <div class="auth-content clearfix">
            <div class="auth-content-left"></div>
            <div class="auth-content-right" style="margin-top: 89px;">
              <h4>{{msg}}</h4>
              <p><a class="z-color-a" target="_blank" href="/help/content_1147.html">查看认证失败的原因以及如何解决</a></p>
            </div>
            <el-button type="primary" class="z-margin-left-20-precent" style="margin-top: 92px;" @click="cert_state = 100">重新提交</el-button>
          </div>
        </div>
      </div>
    </div>
    <xdialog-loading :dialogLoading="dialogLoading"></xdialog-loading>
  </div>
</template>
<script>
  import userService from 'business/userService.js'
  import XdialogLoading from 'components/commons/XdialogLoading.vue'
  import {mapGetters,mapActions} from 'vuex'
  export default {
    data () {
      return {
        dialogLoading:false,
        cert_state:Number,
        info:{},
        msg:''
      }
    },
    components:{
      XdialogLoading,
    },
    props:{
      hide:Boolean
    },
    mounted() {
      this.getState()
    },
    methods:{
      ...mapActions(['SETTHREE_MENU']),
      async getState() {
        let data = 'cmd=smrz_info'
        let {vueData, state} = await userService.transformToVue('smrzInfo','POST',data)
        if(vueData.response == 200 ) {
          this.cert_state = 0
          this.msg = vueData.msg
          if(this.cert_state == 2) {
            this.info = vueData.info
          }
        }else {
          this.$toast('请刷新页面','fail')
        }
      },
      goPersonal(){
        this.$router.push('/auth/personalAuth')
      },
      goEnterprise(){
        this.$router.push('/auth/enterpriseAuth')
      }
    }
  }
</script>
<style scoped>
  .page {
    margin-top: 45px;
    width: 100%;
  }
  .hideleft { margin-left: 80px; }

  .licontant {
    cursor: pointer;
    width: 95%;
    border: 1px solid #e9e9e9;
    padding: 32px 0;
    margin-top: 30px;
  }
  .iconimg {
    display: inline-block;
    width: 69px;
    height: 58px;
    margin-left: 30px;
    background: url(../../assets/imgs/auth-1.png) no-repeat;
  }
  .iconimg.company {
    background: url(../../assets/imgs/auth-2.png) no-repeat;
  }
  .auth-container {
    border: 1px solid #eee;
  }
  .auth-content {
    margin: 40px 0 90px 255px;
  }
  .auth-content-left {
    float: left;
    margin-top: 48px;
    width: 141px;
    height: 117px;
    background: url(../../assets/imgs/auth-success.png) no-repeat;
  }
  .auth-content-right {
    float: left;
    margin-left: 105px;
  }
  .auth-content-right h4 {
    font-size: 26px;
    color: #333;
    margin-bottom: 20px;
  }
  .auth-content-right p {
    line-height: 32px;
  }
  .auth-content-right span {
    color: #ababab;
  }
</style>




// WEBPACK FOOTER //
// src/pages/user/auth.vue